import React, { useMemo, useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { toggleScroll } from '../.';
import style from './index.module.scss';
import { Nav } from './nav';
import NewCentreSelector from '../../new-centre-selector';
import CentreSearchBar from './centre-search-bar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const lookupPath = (items, path) => {
  if (!items || !path.length) {
    return [];
  }
  const [key, ...rest] = path;
  const i = items.findIndex(item => (item === null || item === void 0 ? void 0 : item.key) === key);
  if (i === -1) {
    return [];
  }
  const item = items[i];
  return [i, ...lookupPath(item.items, rest)];
};
export const HamburgerMenu = _ref => {
  let {
    country,
    centre,
    giftCards,
    initialPath,
    onClose,
    menuId
  } = _ref;
  useEffect(() => () => toggleScroll(false), []);
  const membershipLabel = 'Membership';
  const membershipUrl = '/membership';
  const {
    0: query,
    1: setQuery
  } = useState('');
  const getCentreSearchBar = useCallback(() => /*#__PURE__*/_jsx(CentreSearchBar, {
    onChange: setQuery,
    "data-id": "hamburger-menu_index_getCentreSearchBar_CentreSearchBar"
  }), []);
  const findACentreNodes = useMemo(() => [getCentreSearchBar, () => /*#__PURE__*/_jsx(NewCentreSelector, {
    query: query,
    mode: "hamburger",
    "data-id": "hamburger-menu_index_getCentreSearchBar_NewCentreSelector"
  })], [query, getCentreSearchBar]);
  const items = useMemo(() => [{
    key: 'explore-westfield',
    label: 'Explore Westfield',
    url: '/',
    className: classNames(style['item-big'])
  }, centre ? {
    key: 'centre',
    title: "Visit ".concat(centre.title),
    hideTitle: true,
    items: [() => /*#__PURE__*/_jsxs("div", {
      className: classNames(style.item),
      "data-id": "hamburger-menu_index_getCentreSearchBar_div",
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames(style.title),
        "data-id": "hamburger-menu_index_getCentreSearchBar_div_div_3",
        children: centre.title
      }), /*#__PURE__*/_jsx("button", {
        className: classNames(style.link),
        onClick: () => {
          setPath(lookupPath(items, ['find-a-centre']));
          trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, "Edit centre");
        },
        "data-id": "hamburger-menu_index_getCentreSearchBar_div_button",
        children: "Change"
      })]
    }), {
      key: 'Home',
      label: 'Home',
      url: "/".concat(centre.slug)
    }, ...centre.navigationMenu],
    className: classNames(style['item-big'])
  } : findACentreNodes && {
    key: 'find-a-centre',
    title: 'Find a centre',
    items: findACentreNodes,
    className: classNames(style['item-big'])
  }, giftCards && {
    key: 'gift-cards',
    title: 'Gift cards',
    items: giftCards,
    className: classNames(style['item-big'])
  }, ...(country === 'Australia' ? [{
    key: 'the-edit',
    label: 'The Edit',
    url: '/the-edit',
    className: classNames(style['item-big'])
  }] : []), centre && findACentreNodes && {
    key: 'find-a-centre',
    title: 'Find a centre',
    items: findACentreNodes
  }, {
    key: 'westfield-plus',
    label: membershipLabel,
    url: membershipUrl,
    attrs: {
      target: '_blank',
      rel: 'noopener noreferrer'
    }
  }, {
    key: 'support',
    label: 'Customer Support',
    url: country === 'New Zealand' ? 'https://support.westfield.co.nz' : 'https://support.westfield.com.au'
  }], [country, centre, giftCards, findACentreNodes, membershipLabel, membershipUrl]);
  const {
    0: path,
    1: setPath
  } = useState(() => initialPath ? lookupPath(items, initialPath.filter(Boolean)) : []);
  return /*#__PURE__*/_jsx(Nav, {
    menuId: menuId,
    items: items,
    initialPath: path,
    onClose: onClose,
    "data-id": "hamburger-menu_index_getCentreSearchBar_Nav"
  });
};